var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"popup"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body"},[_vm._t("body")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }